import styles from './Loading.module.css';

const Loading = () => {
    return ( 
<div className={styles.loading}>
    <img className={styles.logo} src="/logo_spinner.png" alt="Logo" />
    <h2>Loading...</h2>
</div>

     );
}
 
export default Loading;